var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSso = function SvgSso(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17,
    height: 16,
    fill: "none",
    viewBox: "0 0 17 16"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M11.833 6A1.33 1.33 0 0 0 10.5 4.667m0 5.333a4 4 0 1 0-3.964-3.462c.039.29.058.434.045.526a.6.6 0 0 1-.078.23c-.045.081-.125.16-.284.32L2.812 11.02a1.4 1.4 0 0 0-.214.24.7.7 0 0 0-.08.193c-.018.077-.018.158-.018.321v1.158c0 .374 0 .56.073.703a.67.67 0 0 0 .291.291c.143.073.33.073.703.073h1.6v-1.333H6.5v-1.334h1.333l1.053-1.052c.16-.16.239-.239.32-.284a.6.6 0 0 1 .23-.078c.092-.013.237.006.526.045q.265.036.538.036"
  })));
};
export default SvgSso;